export default __webpack_public_path__ + "static/media/somnium_space.158a039a.svg";